import { Language } from '@configs/language';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import TableConvertData from '../services/TableConvertData.service';
import RECEIVABLES_TABS_NUMBER from '../constants/ReceivableTabs.constants';
import RECEIVABLES_TABLE_HEADERS from '../constants/ReceivablesTableHeader.constants';
import RECEIVABLES_TABS from '../constants/ReceivablesTable.constants';

interface UseTableControllerProps {
  initialTab?: number;
}

const useTableController = ({
  initialTab = RECEIVABLES_TABS_NUMBER.MOVEMENTS,
}: UseTableControllerProps = {}) => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;
  const fixedLanguage = language.toUpperCase() as Language;

  const [selectedTab, setSelectedTab] = useState(initialTab);

  const tableConvertData = useMemo(
    () => new TableConvertData(t, fixedLanguage),
    [t, fixedLanguage]
  );
  const tableType: 'MOVEMENTS' | 'COLLECT_LOCAL_PAYMENT' = useMemo(
    () =>
      selectedTab === RECEIVABLES_TABS_NUMBER.MOVEMENTS
        ? 'MOVEMENTS'
        : 'COLLECT_LOCAL_PAYMENT',
    [selectedTab]
  );
  const tableHeaders = useMemo(
    () => RECEIVABLES_TABLE_HEADERS[RECEIVABLES_TABS.MOVEMENTS],
    []
  );

  const handleChange = (newselectedTab: number) => {
    setSelectedTab(newselectedTab);
  };

  return {
    tableConvertData,
    tableType,
    selectedTab,
    tableHeaders,
    handleChange,
  };
};

export default useTableController;
